import { sectorToColour } from '../../../functions/sector-to-colour';
import { sectorToDarkColour } from '../../../functions/sector-to-dark-colour';
import { sectorToLightColour } from '../../../functions/sector-to-light-colour';
import { Sector } from '../../../model/sector';
import { DashboardColours } from '../../../public/dashboard/shared/model/dashboard-colours';

export function sectorToDashboardColour(sector: Sector): DashboardColours {
  return {
    main: sectorToColour(sector),
    dark: sectorToDarkColour(sector),
    light: sectorToLightColour(sector),
  };
}
